
const VocabWorkingHours = {
    'set_working_hours' : ['Establece tu horario de trabajo', 'Set your working hours'],
    'working_hours' : ['Horario laboral', 'Working hours'],
    'monday' : ['Lunes', 'Monday'],
    'tuesday' : ['Martes', 'Tuesday'],
    'wednesday' : ['Miércoles', 'Wednesday'],
    'thursday' : ['Jueves', 'Thursday'],
    'friday' : ['Viernes', 'Friday'],
    'saturday' : ['Sábado', 'Saturday'],
    'sunday' : ['Domingo', 'Sunday'],
    'workable_day' : ['Día laborable', 'Workable day'],
    'sunday' : ['Domingo', 'Sunday'],
    'no_assigned_schedules': ['No hay horarios asignados', 'There are no assigned schedules'],

    'add_time_slot' : ['Añadir intervalo', 'Add interval'],
    'manage_my_agenda' : ['Gestionar mi agenda con MedCleir ', 'Manage my agenda with MedCleir '],
    'manage_my_agenda_hint' : [
      'Si está habilitada, MedCleir permitirá a los pacientes pacientes reservar en su agenda', 
      "If enabled, MedCleir will allow patients to book your available time slots."],

    'make_schedule_visible' : ['Hacer visibles mis horarios ', 'Make my schedule visible '],
    'make_schedule_visible_hint' : [
      'Si está habilitada, MedCleir mostrará públicamente su horario laboral.', 
      "If enabled, the MedCleir will publicly display your working hours",
    ],
    'validation_error_label' : ['Error de validación', 'Validation error'],
    'validation_error_message' : [
      'Por favor, corrija los intervalos de tiempo con borde rojo. Los intervalos no pueden superponerse y la hora de inicio debe ser anterior a la hora de finalización', 
      'Please fix the red-bordered time slots. Intervals cannot overlap, and start time must be before end time.'
    ],
    

    '' : ['', ''],

  }
  export default VocabWorkingHours;